import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaMedicoItemAutorizado.vue?vue&type=template&id=c3c970c4&scoped=true"
import script from "./ModalSolicitacaoCirurgiaMedicoItemAutorizado.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaMedicoItemAutorizado.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaMedicoItemAutorizado.vue?vue&type=style&index=0&id=c3c970c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c970c4",
  null
  
)

export default component.exports